import { useEffect, useState } from 'react';

export const useIsModalActive = (): boolean => {
  const [isModalActive, setIsModalActive] = useState(false);

  useEffect(() => {
    const handleModalChange = () => {
      setIsModalActive(
        Boolean(
          document.querySelectorAll('.MuiModal-root:not([aria-hidden])').length,
        ),
      );
    };

    const intervalId = setInterval(handleModalChange, 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return isModalActive;
};
